module.exports = __webpack_public_path__ + "teapot.jpg?24ee04acf81d38796a86ff19ce3b90f9";